import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UrlParamsEffects } from './effects/url-params.effects';
import { reducers } from './url-params.store';
import { UrlParamsGuard } from './url-params.guard';
import { AuthenticationService } from './authentication.service';
import { AuthenticationOidcService } from './authentication-oidc.service';

/**
 * Module responsible for parsing input URL params and keep it in store.
 */
@NgModule({
    imports: [
        HttpClientModule,
        StoreModule.forFeature('urlParams', reducers),
        EffectsModule.forFeature([UrlParamsEffects])
    ],
    declarations: [],
    providers: [
        AuthenticationService,
        AuthenticationOidcService
    ]
})
export class UrlParamsModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: UrlParamsModule,
            providers: [UrlParamsGuard]
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/url-params.module.ts